import handleToggle from '../common/handleToggle';

const toggleRadio = (radio) => {
    const radioSiblings = $(radio).siblings('input[type="radio"]');
    const fieldSet = $(radio).parent('fieldset');
    handleToggle(radio, true)();
    handleToggle(fieldSet, true)();
    handleToggle(radioSiblings, false)();
};

export default toggleRadio;



// WEBPACK FOOTER //
// ./src/scripts/components/form/toggleRadio.js